import React from 'react'
import { cloneDeep } from 'lodash'
import { getDataField } from 'utils/constants/dataFields'
import { OPERATION_TYPES } from 'utils/constants/operationTypes'

import { post, put } from 'services/api'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'

import styles from './styles'

export default (props) => {
  const { formData, updateForm, questionKey, Component } = props

  const token = useSelector((state) => state.auth.access_token)
  const form_uuid = useSelector((state) => state.form.uuid)
  const formOwner = useSelector((state) => state.form.owner)

  const classes = styles()

  const saveAnswer = async (data, key, operationType) => {
    const body = {
      question_name: key,
      [`${getDataField(key)}`]: data[getDataField(key)],
    }
    let res
    if (operationType === OPERATION_TYPES.CREATE) {
      res = await post({
        url: `/due_diligence/pf/form/${form_uuid}/question/answer/submit`,
        data: body,
        token,
      })
    } else {
      res = await put({
        url: `/due_diligence/pf/form/${form_uuid}/question/answer/change`,
        data: body,
        token,
      })
    }

    if (res.status === 400) {
      toast.error(
        'Houve um problema ao salvar a resposta, por favor, tente novamente',
      )
    }
  }

  const saveResponses = async (data, key, operationType) => {
    const newFormData = cloneDeep(formData)
    newFormData[key] = data
    await saveAnswer(data, key, operationType).then(() => {
      updateForm(newFormData)
    })
  }

  return (
    <div className={classes.container}>
      <div className={classes.formWrapper}>
        <div className={classes.formLayout}>
          <Component
            questionData={formData[questionKey]}
            saveResponses={saveResponses}
            formOwner={formOwner}
          />
        </div>
      </div>
    </div>
  )
}
